import React from "react";
import { Formik, Field, Form } from "formik";
import { object } from "yup";
import { DatePicker } from "../../components/datetime-picker.component";
import { TextField, RadioGroup, CheckboxWithLabel } from "formik-material-ui";
import Grid from "@material-ui/core/Grid";
import { FormControlLabel, Radio, Typography, Paper } from "@material-ui/core";
import PaymentItemsGridComponent from "../../payments/components/payment_items_grid.component";
import moment from "moment";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import CircularProgress from "@material-ui/core/CircularProgress";

var observations = "";
const defaultInvoiceType = "invoice";
const defaultPaymentType = "payment_type_dd";
const mbObservation =
  "Os artigos/serviços constantes no presente documento, foram colocados à disposição do adquirente, a <date> (alínea f do nº5 do Artº36 CIVA).";
const ddObservation =
  "Os artigos/serviços constantes no presente documento, foram colocados à disposição do adquirente, a <date> (alínea f do nº5 do Artº36 CIVA).\nCobrança por Débito em Conta a partir do dia <payment_at>";
const invoiceDate = new Date();

//
const validationSchema = object().shape({});
const styles = (theme) => ({
  progress: {
    margin: theme.spacing.unit * 2,
  },
});

class NewInvoice extends React.Component {
  state = {
    clientData: {},
  };

  constructor() {
    super();
    this.setPaymentDate = this.setPaymentDate.bind(this);
    this.setObservations = this.setObservations.bind(this);
    this.getInitialObservations = this.getInitialObservations.bind(this);
    this.changeDateObservations = this.changeDateObservations.bind(this);
    this.changeObservations = this.changeObservations.bind(this);
    //
  }

  /**
   *
   */

  componentDidMount() {
    const { clientData } = this.props;
    this.setState({ clientData });
  }

  /**
   *
   */

  setPaymentDate(paymentType, invoiceDate, values) {
    if (
      paymentType === "payment_type_mb" ||
      paymentType === "payment_type_tb"
    ) {
      values.payment_at = invoiceDate;
    }
    if (paymentType === "payment_type_dd") {
      values.payment_at = moment(invoiceDate).add(30, "days");
    }
  }

  getInitialPaymentDate(invoiceDate) {
    let returnDate = new Date(invoiceDate);
    return defaultPaymentType === "payment_type_dd"
      ? moment(returnDate).add(30, "days")
      : returnDate;
  }

  getInitialObservations(invoice_date, payment_at) {
    let observations =
      defaultPaymentType === "payment_type_dd" ? ddObservation : mbObservation;
    observations = observations.replace(
      "<date>",
      moment(invoice_date).format("DD-MM-YYYY")
    );
    observations = observations.replace(
      "<payment_at>",
      moment(payment_at).format("DD-MM-YYYY")
    );
    return observations;
  }

  setObservations(paymentType, invoiceDate, paymentDate, values) {
    if (paymentType === "payment_type_mb") {
      observations = mbObservation;
      observations = observations.replace(
        "<date>",
        moment(invoiceDate).format("DD-MM-YYYY")
      );
    } else {
      observations = ddObservation;
      observations = observations.replace(
        "<date>",
        moment(invoiceDate).format("DD-MM-YYYY")
      );
      observations = observations.replace(
        "<payment_at>",
        moment(paymentDate).format("DD-MM-YYYY")
      );
    }
    values.observations = observations;
  }

  changeDateObservations(event, date, values) {
    let paymentType = values.payment_type;
    if (event === "invoice_date") {
      this.setPaymentDate(paymentType, date, values);
      this.setObservations(
        paymentType,
        new Date(date),
        values.payment_at,
        values
      );
    }
    if (event === "payment_at")
      this.setObservations(
        paymentType,
        values.invoice_date,
        new Date(date),
        values
      );
  }

  changeObservations(event, values) {
    let paymentType = values.payment_type;
    if (event) paymentType = event.target.value;
    //
    this.setPaymentDate(paymentType, values.invoice_date, values);
    this.setObservations(
      paymentType,
      values.invoice_date,
      values.payment_at,
      values
    );
  }

  /**
   *
   */

  render() {
    const { clientData, classes } = this.props;

    if (!clientData)
      return (
        <>
          <p>Não foram encontradas referências easypay para esta entidade</p>
          <button onClick={() => this.props.history.goBack()}>Voltar</button>
        </>
      );

    return clientData.id ? (
      this.renderForm()
    ) : (
      <div>
        <CircularProgress className={classes.progress} color="primary" />
      </div>
    );
  }

  renderForm() {
    const { getForm, onSubmit, payment, clientData } = this.props;

    let invoice_date = invoiceDate;
    let payment_at = this.getInitialPaymentDate(invoice_date);
    let observations = this.getInitialObservations(invoice_date, payment_at);

    return (
      <>
        <Paper square>
          <Formik
            ref={(node) => getForm && getForm(node)}
            initialValues={{
              entity_name: clientData.name,
              entity_email: clientData.email,
              invoice_type: defaultInvoiceType,
              payment_type: defaultPaymentType,
              invoice_date: invoiceDate.toDateString(),
              payment_at: payment_at,
              observations: observations,
              send_email: true,
              payment_items: [payment],
              payment_id: payment.ep_key,
              close_invoice: false,
            }}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
            validateOnChange={false}
            validateOnBlur={false}
            render={({ values, handleSubmit, setFieldValue, isSubmitting }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  <Grid container style={{ width: "95%", margin: "auto" }}>
                    <Grid
                      item
                      md={4}
                      style={{ marginRight: "50px", marginTop: "20px" }}
                    >
                      <Typography variant="h6" color="#4682B4" gutterBottom>
                        Dados do Cliente
                      </Typography>
                      <Field
                        name="entity_name"
                        label="Entidade"
                        variant="outlined"
                        margin="normal"
                        type="text"
                        component={TextField}
                        onChange={setFieldValue}
                        value={"" + values.entity_name}
                        disabled
                        fullWidth
                      />
                      <Field
                        name="entity_email"
                        label="Email"
                        type="email"
                        variant="outlined"
                        margin="normal"
                        component={TextField}
                        onChange={setFieldValue}
                        value={"" + values.entity_email}
                        disabled={!values.send_email}
                        fullWidth
                      />
                      <Field
                        name="send_email"
                        Label={{ label: "Enviar fatura para cliente" }}
                        component={CheckboxWithLabel}
                        onChange={setFieldValue}
                        onClick={() =>
                          (values.entity_email = "paulo.silva@laresonline.pt")
                        }
                        value={"" + values.send_email}
                      />
                    </Grid>

                    <Grid
                      item
                      md={3}
                      style={{ marginRight: "50px", marginTop: "20px" }}
                    >
                      <Typography variant="h6" color="#4682B4" gutterBottom>
                        Dados da Fatura
                      </Typography>

                      <Field
                        name="invoice_date"
                        label="Data da fatura"
                        variant="outlined"
                        margin="normal"
                        component={DatePicker}
                        onChange={(event, date) => {
                          setFieldValue(event, date);
                          this.changeDateObservations(event, date, values);
                        }}
                        value={"" + values.invoice_date}
                        fullWidth
                      />
                      <Field
                        name="payment_at"
                        label="Data da cobrança"
                        variant="outlined"
                        margin="normal"
                        component={DatePicker}
                        onChange={(event, date) => {
                          setFieldValue(event, date);
                          this.changeDateObservations(event, date, values);
                        }}
                        value={"" + values.payment_at}
                        fullWidth
                      />
                      <Field
                        name="invoice_type"
                        component={RadioGroup}
                        onChange={setFieldValue}
                        value={"" + values.invoice_type}
                      >
                        <FormControlLabel
                          value="invoice"
                          control={<Radio />}
                          label="Fatura"
                          disabled={isSubmitting}
                        />
                        <FormControlLabel
                          value="receipt"
                          control={<Radio />}
                          label="Fatura-Recibo"
                          disabled={isSubmitting}
                        />
                      </Field>
                    </Grid>

                    <Grid md={3} style={{ marginTop: "20px" }}>
                      <Typography variant="h6" color="#4682B4" gutterBottom>
                        Método de pagamento
                      </Typography>

                      <Field
                        name="payment_type"
                        component={RadioGroup}
                        onChange={setFieldValue}
                        value={"" + values.payment_type}
                      >
                        <FormControlLabel
                          value="payment_type_mb"
                          control={<Radio />}
                          label="Multibanco"
                          disabled={isSubmitting}
                          onChange={(event) =>
                            this.changeObservations(event, values)
                          }
                        />
                        <FormControlLabel
                          value="payment_type_dd"
                          control={<Radio />}
                          label="Débito Directo"
                          disabled={isSubmitting}
                          onChange={(event) =>
                            this.changeObservations(event, values)
                          }
                        />
                        <FormControlLabel
                          value="payment_type_tb"
                          control={<Radio />}
                          label="Transferência bancária"
                          disabled={isSubmitting}
                          onChange={(event) =>
                            this.changeObservations(event, values)
                          }
                        />
                      </Field>
                    </Grid>

                    <Grid container md={10} style={{ marginTop: "20px" }}>
                      <PaymentItemsGridComponent
                        title={"Items"}
                        canEdit={true}
                        showDate={false}
                        canEditAmount={true}
                        showInvoices={false}
                        nextPayments={[payment]}
                        payments={values.payment_items}
                      />
                    </Grid>

                    <Grid container md={10} style={{ marginTop: "40px" }}>
                      <Typography variant="h6" color="#4682B4" gutterBottom>
                        Observações
                      </Typography>
                      <Field
                        name="observations"
                        label="Observações"
                        variant="outlined"
                        margin="normal"
                        type="text"
                        component={TextField}
                        multiline
                        rows={3}
                        fullWidth
                        onChange={setFieldValue}
                        value={"" + values.observations}
                        defaultValue={observations}
                      />
                    </Grid>
                  </Grid>
                </Form>
              );
            }}
          />
        </Paper>
      </>
    );
  }
}

NewInvoice.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(NewInvoice));
